import React from "react";
import { Box, Typography } from "@mui/material";
import { IconSeeker } from "@ui-seeker/core";


export default function IconDataBlock({ icon, value, extraIcon, iconProps={}, typographyProps={} }) {
  
  return (
    <Box sx={{ whiteSpace: "noWrap" }}>
      <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: "bold", ...typographyProps?.sx }}>
          <IconSeeker icon={icon} {...iconProps} sx={{ mr: 0.5, ...iconProps?.sx }} />
          {value}
          <IconSeeker icon= {extraIcon} sx={{ ml:0.5 }} />
      </Typography>
    </Box>
  );
}